import React from 'react'
import Header from '../HeaderandFooter/Header'
import Blog from './Blog'
import SidebarOptions from '../HeaderandFooter/SidebarOptions'
import { Helmet } from "react-helmet-async";


const MainBlog = () => {
    return (
        <>
            <Helmet>
                <title> Blog | SuperCodingBits </title>
                <meta name="description" content="Stay updated with the latest React.js tutorials, UI development tips, and front-end best practices at SuperCodingBits. Learn how to build modern web applications with clean, efficient code." />
                <meta name="keywords" content="React.js, front-end development, UI components, reusable components, responsive design, clean code, JavaScript, web development" />
            </Helmet>
            <Header />
            <SidebarOptions />
            <div className="sectiondata">
                <Blog />
            </div>
        </>
    )
}

export default MainBlog